//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchCreate, fetchUpdate, fetchDetail, fetchDelete } from '@/api/otherSystem/staticResource/staticResource';
import waves from '@/directive/waves'; // 水波纹指令

import add from './add';
export default {
  components: {
    add: add
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      flowNum: '',
      repairStatu: [],
      downloadUrl: '',
      options: [],
      innerVisible: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      customerId: '',
      id: '',
      imageId: '',
      multipleSelection: [],
      dialogFormVisible: false,
      dialogDetailVisible: false,
      dialogDispatchVisible: false,
      dialogEvaluateVisible: false,
      dialogArchiveVisible: false
    };
  },
  created: function created() {
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      switch (reload) {
        case true:
          this.getList();
          this.dialogFormVisible = false;
          break;

        case 'dispatchRepair':
          this.dialogDispatchVisible = false;
          this.getList();
          break;

        case 'repairAdd':
          this.getList();
          this.dialogFormVisible = false;
          break;

        case 'repairDetail':
          this.getList();
          this.dialogDetailVisible = false;
          break;

        case 'repairEvaluate':
          this.getList();
          this.dialogEvaluateVisible = false;
          break;

        case 'repairArchive':
          this.getList();
          this.dialogArchiveVisible = false;
          break;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.customerId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(customerId, data) {
      console.log(data.imageId, 'dadadad');
      this.imageId = data.imageId;
      this.customerId = customerId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(customerIds) {
      var _this2 = this;

      if (customerIds) {
        this.$confirm('你确定是要删除, 是否继续?', '提示').then(function () {
          fetchDelete({
            id: customerIds
          }).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(customerId) {
      var customerIds = [];
      customerIds.push(customerId);
      this.delete(customerId); // this.delete(customerId)
    }
  }
};